import { useEffect, useMemo, useRef, useState } from 'react';
import { SActionBtn, SFuncModal, SGeneralForms, SLocalTreeSelected } from 'shj-components';
import { Cascader, Input, message, Select } from 'antd';
import { findNodeConfig, findServiceNodeConfigDtlById, insertOrUpdateServiceNodeConfigDtl } from '@/services/serviceConfig';
import moment from 'moment';
import { getProductCategoryTreeList } from '@/services/product';
import { getEnums } from '@/services/homeService';
import { treeFormat } from '@/utils/data';

const { Option } = Select;

export function addFn({ fn, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: '新增/编辑',
        width: 700,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
    const formRef = useRef<any>()
    const inputRef = useRef<any>()
    const [nodeList, setNodeList] = useState<any>([]);
    const [productCategory, setProductCategory] = useState<any>([]);
    const [text, setText] = useState('');
    const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
    const [nodeType, setNodeType] = useState('')
    const [createType, setCreateType] = useState('')
    const [serviceNodeTypeEnumList, setServiceNodeTypeEnumList] = useState<any[]>([]);
    const arr: any = [{
        berforeStr: '节点名称',
        afterStr: '【新增节点】'
    },
    {
        berforeStr: '客户名称',
        afterStr: '【张三】'
    },
    {
        berforeStr: '当前日期',
        afterStr: `【${moment(new Date()).format('YYYY-MM-DD')}】`
    }];
    const initFn = () => {
        if (rest?.id) {
            setConfirmLoading(true)
            findServiceNodeConfigDtlById(rest?.id).then(res => {
                formRef.current?.onFormRef()?.setFieldsValue({ ...res })
                setConfirmLoading(false)
                if (res.nodeType === 'serviceMsg') {
                    setText(res.msgModel)
                }
                setNodeType(res.nodeType)
                setCreateType(res.createType)
            })
        }
    }
    useEffect(() => {
        initFn()
    }, [])
    // 提交
    const onFinish = () => {
        formRef?.current?.onFormRef()?.setFieldValue('msgModel', text)
        formRef.current?.onFormRef()?.validateFields().then((values) => {
            setConfirmLoading(true)
            const value = formRef?.current?.onFormRef()?.getFieldsValue()
            insertOrUpdateServiceNodeConfigDtl(
                { ...value, msgModel: text, serviceNodeId: rest.serviceNodeId }
            ).then((res) => {
                message.success(res?.message || "操作成功");
                setConfirmLoading(false);
                onClose();
                fn && fn();
            }).catch((err) => {
                message.error(err?.message || "操作失败");
                setConfirmLoading(false);
            })
        })
    }
    const closeModal = () => {
        onClose();
    };
    const getOptions = async (): Promise<any> => {
        const serviceNodeTypeEnum = await getServiceNodeTypeEnum();
        const serviceCreateTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.node.enums.ServiceCreateTypeEnum")
        const nodeListRes = await findNodeConfig(1, 100, {});
        const productCategory = await getProductCategoryTreeList({ enabled: true, modeFlags: [4] });
        setNodeList(nodeListRes.records);
        setProductCategory(productCategory);
        
        return new Promise(async (resolve) => {
            resolve({
                serviceNodeTypeEnum: serviceNodeTypeEnum.map(item => {
                    return {
                        ...item,
                        disabled: formRef.current?.onFormRef()?.getFieldValue('typeName') == '开工'?(item?.key =='serviceConfirm'?true:false):false
                    }
                }),
                serviceCreateTypeEnum,
            });
        });
    }

    const getServiceNodeTypeEnum = async() => {
        const serviceNodeTypeEnum = (await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.node.enums.ServiceNodeTypeEnum")) as any[] || [];
        setServiceNodeTypeEnumList(serviceNodeTypeEnum);
        return serviceNodeTypeEnum;
    }

    const onSelectNodeName = async(value, data) => {
        formRef?.current?.onFormRef()?.setFieldValue('typeName', data?.dataTypeName);
        formRef?.current?.onFormRef()?.setFieldValue('nodeId', data?.key);
        let serviceNodeTypeEnum = serviceNodeTypeEnumList;
        if(data?.type == 'startWorkType'){
            formRef?.current?.onFormRef()?.setFieldValue('nodeType', '');
        }
        if(serviceNodeTypeEnumList && serviceNodeTypeEnumList.length == 0){
            serviceNodeTypeEnum = await getServiceNodeTypeEnum();
        }
        formRef.current?.updateState({
            serviceNodeTypeEnum: serviceNodeTypeEnum.map(item => {
                return {
                    ...item,
                    disabled: data?.type == 'startWorkType'?(item?.key =='serviceConfirm'?true:false):false
                }
            }),
        })
    }
    const onSearchontNodeName = async (value) => {
        const nodeListRes = await findNodeConfig(1, 100, { name: value })
        setNodeList(nodeListRes.records)
    }
    const handleClick = (text) => {
        if(text.length + inputRef.current.input.value.length > 200) 
            return message.warning('通知模板最大长度为200个字符')
        insertTextAtCursor(text);
    }

    const insertTextAtCursor = (textToInsert) => {
        const inputFormRef = inputRef.current;
        if (inputFormRef) {
            inputFormRef.focus();
            const startPos = inputFormRef.input.selectionStart;
            const endPos = inputFormRef.input.selectionEnd;
            const currentValue = inputFormRef.input.value;
            const newValue = currentValue.substring(0, startPos) + 
                             `【$${textToInsert}$】` + 
                             currentValue.substring(endPos);
            setText(newValue);
            
            // 设置光标位置到插入文本之后
            setTimeout(() => {
                const newCursorPosition = startPos + textToInsert.length + 4; // 5 是因为【$和$】的长度
                inputFormRef.input.setSelectionRange(newCursorPosition, newCursorPosition);
            }, 0);
        }
    };
    const transformStr = () => {
        let newStr = text;
        arr.forEach(item => {
            const reg = new RegExp(`【\\$${item.berforeStr}\\$】`, 'g');
            newStr = newStr.replace(reg, item.afterStr)
        })
        return newStr
    }
    const previewNotice = () => {
        SFuncModal({
            title: '预览',
            width: 500,
            content: transformStr(),
            footer: null
        })
    }
    const onChangeState = (value) => {
        setNodeType(value)
        if (value === 'serviceConfirm') {
            setText('')
        }
    }
    const onChangeType = (value) => {
        setCreateType(value)
        if (value === 'createFixed') {
            formRef?.current?.onFormRef()?.setFieldValue('prodCatIds', null)
        }
    }
    // 添加一个函数来检查节点是否为叶子节点
    const treeData = useMemo(
        () => treeFormat(productCategory || [], {
            format: (item) => ({ ...item, disabled: (item.children || []).length })
        }),
        [productCategory]
    )
    return (
        <div>
            <SFuncModal.Content
                onCancel={closeModal}
                onOk={onFinish}
                confirmLoading={confirmLoading}>
                <SGeneralForms
                    ref={formRef}
                    layout="vertical"
                    httpOptionsFn={getOptions}
                    initialValues={{ status: true }}
                    configs={[
                        {
                            title: '',
                            formItem: [
                                { label: 'id', name: 'id', hidden: true },
                                { label: 'nodeId', name: 'nodeId', hidden: true },
                                {
                                    label: '节点名称',
                                    name: 'nodeName',
                                    spanCol: 12,
                                    required: true,
                                    type: "select",
                                    data: 'nodeList',
                                    children: <Select showSearch={true} onSearch={onSearchontNodeName}
                                        onChange={onSelectNodeName}
                                        placeholder={'请选择节点名称'}>
                                        {nodeList.map((item: any) => (
                                            <Option key={item?.id} value={item?.name} dataTypeName={item?.typeName} type={item?.type} >
                                                {item.name}
                                            </Option>
                                        ))}
                                    </Select>
                                },
                                {
                                    label: '节点类型',
                                    name: 'typeName',
                                    spanCol: 12,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    label: '生成方式',
                                    name: 'createType',
                                    tooltip: '按需：根据客户购买产品生成确认节点。固定：每个产品在服务过程中固定生成需要客户确定节点',
                                    spanCol: 12,
                                    required: true,
                                    type: "select",
                                    data: 'serviceCreateTypeEnum',
                                    comConfig: {
                                        fieldNames: {
                                            label: 'description',
                                            value: 'key'
                                        },
                                        onChange: onChangeType,
                                    }
                                },
                                {
                                    label: '节点方式',
                                    tooltip: '确认：节点提交验收后需要客户确认通过该节点才算完成，通知：节点提交验收后节点完成，并给客户发送通知消息',
                                    name: 'nodeType',
                                    spanCol: 12,
                                    required: true,
                                    type: "select",
                                    data: 'serviceNodeTypeEnum',
                                    comConfig: {
                                        fieldNames: {
                                            label: 'description',
                                            value: 'key'
                                        },
                                        onChange: onChangeState,
                                    }
                                },
                                {
                                    label: '产品分类',
                                    name: 'prodCatIds',
                                    spanCol: 12,
                                    required: createType !== 'createFixed',
                                    hidden: createType === 'createFixed',
                                    children:
                                        <SLocalTreeSelected treeCheckable treeDefaultExpandAll
                                            fieldNames={{ label: 'cateName', value: 'id' }}
                                            treeData={treeData} />
                                },
                                {
                                    label: '状态',
                                    name: 'status',
                                    spanCol: 12,
                                    required: true,
                                    type: "switch",
                                },
                                {
                                    name: 'remarks',
                                    label: '说明',
                                    spanCol: 24,
                                    type: "textarea",
                                    comConfig: {
                                        maxLength: 200,

                                    },
                                },
                                {
                                    name: 'acceptanceCriteria',
                                    label: '服务标准',
                                    type: "textarea",
                                    required: true,
                                    spanCol: 24,
                                    comConfig: {
                                        maxLength: 200,
                                    },
                                },

                                {
                                    name: 'msgModel',
                                    label: '通知模板',
                                    required: nodeType !== 'serviceConfirm',
                                    spanCol: 24,
                                    hidden: nodeType != 'serviceMsg',
                                    children: <>
                                        <Input
                                            maxLength={200}
                                            ref={inputRef}
                                            value={text}
                                            onChange={(e) => setText(e.target.value)}
                                            suffix={<SActionBtn onClick={previewNotice}>预览</SActionBtn>}
                                        />
                                        <SActionBtn onClick={() => { handleClick('节点名称') }}>节点名称</SActionBtn><SActionBtn onClick={() => { handleClick('客户名称') }}>客户名称</SActionBtn><SActionBtn onClick={() => { handleClick('当前日期') }}>当前日期</SActionBtn>
                                    </>

                                },
                            ]
                        }
                    ]}
                />
            </SFuncModal.Content>
        </div>
    );
};
